export interface Article {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  author: string;
  summary: string;
  content: string;
  image: string;
  tags: string[];
  relatedIds: string[];
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "流浪地球2：国产科幻电影的里程碑之作",
    category: "影评",
    categorySlug: "reviews",
    date: "2024-03-15",
    author: "影视观察员",
    summary: "《流浪地球2》不仅延续了前作的宏大叙事，更在视觉特效和情感深度上全面升级，标志着中国科幻电影迈入新纪元。本文从剧情、特效、角色等多个维度为您深度解析这部国产科幻巨制。",
    content: `## 引言

《流浪地球2》作为《流浪地球》的前传，讲述了人类在面临太阳危机时，如何团结一致推动"移山计划"的故事。这部由郭帆执导的科幻大片，不仅在票房上取得了巨大成功，更在艺术和技术层面树立了国产科幻的新标杆。

## 视觉特效的飞跃

相比第一部，《流浪地球2》的视觉特效有了质的飞跃。太空电梯的震撼场景、月球碎片坠落的灾难画面、以及数字生命卡的技术呈现，都达到了世界一流水平。影片中的太空场景宏大而真实，让观众仿佛置身于浩瀚宇宙之中。

## 情感内核的深化

影片不仅仅是一部视觉盛宴，更深刻地探讨了"数字生命"与"现实生命"的哲学命题。刘德华饰演的图恒宇为了拯救女儿而不惜一切代价，吴京饰演的刘培强则展现了父爱的另一种表达方式。两条情感线交织在一起，构成了影片最动人的部分。

## 演员表现的突破

李雪健老师饰演的周喆直，以沉稳有力的表演诠释了一位在大灾变面前依然保持信念的领导者形象。刘德华的加盟为影片注入了新的活力，他与女儿之间的情感羁绊令人动容。

## 总结

《流浪地球2》是一部在商业性和艺术性上都取得了巨大成功的科幻电影。它不仅让观众享受到顶级的视听体验，更引发了关于人类命运、科技伦理的深层思考。这部电影标志着中国科幻电影的新高度。`,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20scene%2C%20futuristic%20space%20station%20interior%2C%20astronauts%20working%2C%20Earth%20visible%20through%20window%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20warm%20golden%20tones%2C%20professional%20film%20still%20quality&width=1200&height=600&seq=article-image-01&orientation=landscape",
    tags: ["科幻", "影评", "国产电影", "流浪地球"],
    relatedIds: ["article-3", "article-5"],
  },
  {
    id: "article-2",
    title: "《狂飙》为何成为现象级爆款剧？深度剖析",
    category: "剧评",
    categorySlug: "reviews",
    date: "2024-02-28",
    author: "追剧达人",
    summary: "《狂飙》自播出以来热度持续攀升，成为2023年当之无愧的现象级爆款剧。从人物塑造到剧情设计，从社会意义到演员表演，这部剧究竟有何魔力？",
    content: `## 现象级爆款的诞生

《狂飙》的播出引发了一场全民追剧热潮。这部剧以扫黑除恶为主题，讲述了一线刑警安欣与黑恶势力长达二十年的斗争故事。其成功不仅仅在于紧张刺激的剧情，更在于对人性的深刻描摹。

## 张颂文的封神演技

张颂文饰演的高启强，从一个受人欺负的鱼贩，一步步成长为称霸一方的黑恶势力头目。这种"逆袭"式的角色成长曲线，加上张颂文收放自如的演技，让观众对这个反派角色既恨又怜。高启强的人物弧光，成为了中国电视剧史上最令人印象深刻的角色之一。

## 张译的精准演绎

相比高启强的张扬，张译饰演的安欣则以内敛克制的表演赢得了观众的尊重。安欣二十年来始终坚守正义的执着，与高启强的堕落形成了强烈的戏剧对比，这种正邪对立构成了剧集最核心的张力。

## 社会意义的深度

《狂飙》不仅仅是一部娱乐作品，它深刻地反映了中国社会扫黑除恶的艰难历程。剧中涉及的保护伞问题、基层腐败问题，都是现实社会的缩影，引发观众的广泛共鸣和讨论。

## 群像塑造的成功

除了两位主角，《狂飙》中每一个配角都鲜活立体。无论是高启强的弟弟高启盛，还是忠心耿耿的唐小虎，都有自己完整的人物弧光和故事线。这种群像式的叙事手法，让整部剧更加丰富饱满。`,
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20scene%2C%20two%20men%20confronting%20each%20other%20in%20urban%20night%20setting%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20Chinese%20police%20drama%20aesthetic%2C%20dark%20and%20gritty%20visual%20style&width=1200&height=600&seq=article-image-02&orientation=landscape",
    tags: ["剧评", "国产剧", "狂飙", "张颂文"],
    relatedIds: ["article-4", "article-6"],
  },
  {
    id: "article-3",
    title: "2024年最值得期待的十部国产电影",
    category: "资讯",
    categorySlug: "news",
    date: "2024-05-01",
    author: "电影情报局",
    summary: "2024年国产电影市场精彩纷呈，从科幻大片到现实主义力作，从动画电影到文艺佳片，我们精选了十部最值得期待的国产电影，为你提前揭晓今年的观影清单。",
    content: `## 2024国产电影前瞻

2024年是中国电影市场的关键一年。经过2023年的强势复苏，今年将有更多重磅作品与观众见面。以下是本年度最值得期待的十部国产电影。

### 1. 《封神第二部》

在首部取得口碑票房双丰收后，《封神第二部》将继续讲述武王伐纣的宏大史诗。乌尔善导演表示第二部将会有更多神仙大战的震撼场面。

### 2. 《哪吒之魔童闹海》

作为《哪吒之魔童降世》的续集，这部动画电影承载着无数观众的期待。饺子导演五年磨一剑，誓要再创国漫新高度。

### 3. 《热辣滚烫》

贾玲导演的第二部作品，讲述了一个关于拳击和自我救赎的故事。影片在春节档上映后取得了惊人的票房成绩。

### 4. 《飞驰人生2》

韩寒回归执导，沈腾领衔主演的赛车题材喜剧续作。时隔五年，张驰的故事再次上演，笑中带泪的赛车之旅令人期待。

### 5. 《第二十条》

张艺谋执导的现实主义题材影片，聚焦正当防卫这一法律议题，由雷佳音、马丽等实力派演员主演，引发社会广泛讨论。`,
    image: "https://readdy.ai/api/search-image?query=Chinese%20cinema%20movie%20theater%20interior%2C%20modern%20cinema%20with%20red%20seats%2C%20golden%20warm%20lighting%2C%20movie%20poster%20displays%20on%20walls%2C%20cinematic%20atmosphere%2C%20professional%20photography%2C%20elegant%20and%20inviting%20space&width=1200&height=600&seq=article-image-03&orientation=landscape",
    tags: ["资讯", "国产电影", "2024", "电影推荐"],
    relatedIds: ["article-1", "article-5"],
  },
  {
    id: "article-4",
    title: "《繁花》：王家卫的电视剧美学革命",
    category: "剧评",
    categorySlug: "reviews",
    date: "2024-01-20",
    author: "萤幕观察",
    summary: "王家卫首次执导电视剧《繁花》引发广泛关注。这部以九十年代上海为背景的年代剧，以其独特的影像美学和叙事风格，为国产电视剧带来了一场美学革命。",
    content: `## 王家卫的电视剧首秀

当王家卫宣布要拍摄电视剧《繁花》时，整个影视圈为之震动。这位以独特影像风格著称的电影导演，能否在电视剧这一不同媒介中延续他的艺术追求？

## 影像美学的极致追求

《繁花》的每一帧画面都像是一幅精心构图的摄影作品。暖黄色的灯光、上海的弄堂街巷、精致的服装道具，共同营造出浓郁的九十年代上海风情。这种极致的影像美学在国产电视剧中实属罕见。

## 胡歌的演技新高度

胡歌在《繁花》中饰演的阿宝，是其演艺生涯中最具挑战性的角色之一。从市井小人物到商界精英的蜕变，胡歌用细腻的表演完美呈现了角色内心的复杂变化。

## 群像叙事的魅力

除了阿宝的主线，《繁花》还勾勒了黄河路上形形色色的人物群像。马伊琍饰演的玲子、唐嫣饰演的汪小姐、辛芷蕾饰演的李李，每个角色都有自己鲜明的个性和故事。

## 时代的回响

《繁花》不仅仅是一部电视剧，它是对九十年代上海的深情回望。那个充满机遇、激情和不确定性的年代，通过王家卫的镜头重新鲜活起来。`,
    image: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%2C%20neon%20lights%2C%20vintage%20Chinese%20city%20atmosphere%2C%20people%20in%20retro%20clothing%2C%20warm%20golden%20lighting%2C%20nostalgic%20cinematic%20look%2C%20film%20noir%20aesthetic%2C%20rain%20on%20pavement&width=1200&height=600&seq=article-image-04&orientation=landscape",
    tags: ["剧评", "繁花", "王家卫", "胡歌"],
    relatedIds: ["article-2", "article-6"],
  },
  {
    id: "article-5",
    title: "国漫崛起：从《哪吒》到《深海》的进化之路",
    category: "资讯",
    categorySlug: "news",
    date: "2024-04-10",
    author: "动漫爱好者",
    summary: "近年来国产动画电影持续发力，从《大圣归来》到《哪吒之魔童降世》，再到《深海》，国漫在技术与叙事上不断突破。本文将回顾国漫的崛起之路。",
    content: `## 国漫的新时代

十年前，没有人能预料到国产动画电影会有今天的成就。从2015年《大圣归来》的黑马突围，到2019年《哪吒之魔童降世》以50亿票房刷新纪录，国漫走过了一条令人振奋的崛起之路。

## 技术突破：《深海》的粒子水墨

2023年上映的《深海》在技术上实现了重大突破。导演田晓鹏团队历时七年研发的"粒子水墨"技术，将中国传统水墨画与现代CG技术完美融合，创造出前所未有的视觉奇观。

## 叙事升级：从神话改编到原创故事

早期的国漫电影多依赖中国传统神话IP，如《大圣归来》《哪吒》《白蛇》等。而到了《深海》，国漫开始尝试原创故事，探讨更为深刻的主题——抑郁症、孤独感、自我救赎等。

## 产业生态的完善

国漫的崛起不仅仅是几部爆款电影的功劳。背后是整个动画产业链的成熟：人才培养体系的完善、资本市场的关注、观众审美的提升，共同推动了国漫产业的发展。

## 未来展望

随着《哪吒2》《大圣归来2》等续作的推出，以及更多原创动画的诞生，国漫的未来值得期待。从技术到内容，从国内市场到国际舞台，国漫正在书写属于自己的传奇。`,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20concept%20art%2C%20traditional%20Chinese%20ink%20painting%20style%20with%20modern%20CG%20elements%2C%20underwater%20fantasy%20scene%2C%20colorful%20particle%20effects%2C%20artistic%20and%20dreamlike%20atmosphere%2C%20beautiful%20composition&width=1200&height=600&seq=article-image-05&orientation=landscape",
    tags: ["资讯", "国漫", "动画电影", "深海"],
    relatedIds: ["article-1", "article-3"],
  },
  {
    id: "article-6",
    title: "高分韩剧推荐：这五部必看神作不容错过",
    category: "推荐",
    categorySlug: "recommend",
    date: "2024-03-05",
    author: "韩剧达人",
    summary: "韩剧以其精良的制作和扣人心弦的剧情持续吸引全球观众。本文精选五部高分必看韩剧，涵盖悬疑、爱情、奇幻等多种类型，总有一部适合你。",
    content: `## 韩剧推荐清单

韩国电视剧产业在过去十年间经历了爆发式增长，从制作水准到剧本质量都有了质的飞跃。以下是五部不容错过的高分韩剧推荐。

### 1. 《黑暗荣耀》

宋慧乔主演的复仇题材剧集，讲述了一个在校园暴力中受尽欺凌的女孩，花费十八年时间精心策划复仇的故事。剧本紧凑有力，演员表现炸裂，Netflix全球热播。

### 2. 《我的解放日志》

一部关于普通人生活的治愈系剧集。三兄妹在首尔郊区的平凡日常，却蕴含着深刻的人生哲理。金智媛、孙锡久的主演组合化学反应满分。

### 3. 《非常律师禹英禑》

朴恩斌饰演患有自闭症的天才律师禹英禑，这部剧以温暖幽默的方式探讨了社会对特殊群体的包容问题。每集一个案件，既有法律剧的悬疑感，又有成长剧的治愈力。

### 4. 《财阀家的小儿子》

宋仲基主演的穿越重生题材剧集，讲述了一个被财阀家族谋杀的员工，重生为财阀家小儿子的故事。剧情反转不断，收视率节节攀升。

### 5. 《浪漫速成班》

全度妍和郑敬淏主演的浪漫喜剧，讲述了一个前国家代表队运动员转行开小菜店，与明星数学讲师之间的爱情故事。轻松搞笑又不失温情。`,
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20aesthetic%2C%20modern%20Seoul%20cityscape%20at%20night%2C%20warm%20neon%20lights%2C%20romantic%20atmosphere%2C%20Korean%20cinematography%20style%2C%20beautiful%20composition%2C%20soft%20golden%20lighting%2C%20dreamy%20mood&width=1200&height=600&seq=article-image-06&orientation=landscape",
    tags: ["推荐", "韩剧", "高分剧集", "必看"],
    relatedIds: ["article-2", "article-4"],
  },
];